export default "__VITE_ASSET__Dna7zAv9__"